import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'material-design-icons-iconfont/dist/material-design-icons.css'

const custom_icons = {
  ic_home: require('../assets/icon/ic_home.svg'),
  ic_business: require('../assets/icon/ic_business.svg'),
  ic_analytics: require('../assets/icon/ic_analytics.svg'),
  ic_brochurer: require('../assets/icon/ic_brochurer.svg'),
  ic_brochurer: require('../assets/icon/ic_brochurer.svg'),
  ic_contacts: require('../assets/icon/ic_contacts.svg'),
  ic_gallery: require('../assets/icon/ic_gallery.svg'),
  ic_inbox: require('../assets/icon/ic_inbox.svg'),
  ic_preview: require('../assets/icon/ic_preview.svg'),
  ic_profile: require('../assets/icon/ic_profile.svg'),
  ic_card_privacy: require('../assets/icon/ic_card_privacy.svg'),

  // -----------social media---------- 

  clicks: require('../assets/social/lnr_clicks.svg'),
  views: require('../assets/social/lnr_views.svg'),
  email: require('../assets/social/lnr_email.svg'),
  phone: require('../assets/social/lnr_phone.svg'),
  website: require('../assets/social/lnr_website.svg'),
  download: require('../assets/social/lnr_download.svg'),
  social: require('../assets/social/lnr_social.svg'),
  gallery: require('../assets/social/lnr_gallery.svg'),
  address: require('../assets/social/lnr_address.svg'),
  details: require('../assets/social/lnr_details.svg'),

  angellist: require('../assets/social/angellist.svg'),
  askfm: require('../assets/social/askfm.svg'),
  behance: require('../assets/social/behance.svg'),
  blogspot: require('../assets/social/blogspot.svg'),
  classmates: require('../assets/social/classmates.svg'),
  dailymotion: require('../assets/social/dailymotion.svg'),
  dribbble: require('../assets/social/dribbble.svg'),
  facebook: require('../assets/social/facebook.svg'),
  fbmessenger: require('../assets/social/fbmessenger.svg'),
  flickr: require('../assets/social/flickr.svg'),
  foursquare: require('../assets/social/foursquare.svg'),
  github: require('../assets/social/github.svg'),
  goodReads: require('../assets/social/goodreads.svg'),
  imo: require('../assets/social/imo.svg'),
  instagram: require('../assets/social/instagram.svg'),
  linkedin: require('../assets/social/linkedin.svg'),
  medium: require('../assets/social/medium.svg'),
  meetme: require('../assets/social/meetme.svg'),
  meetup: require('../assets/social/meetup.svg'),
  pexels: require('../assets/social/pexels.svg'),
  pinterest: require('../assets/social/pinterest.svg'),
  qq: require('../assets/social/qq.svg'),
  quora: require('../assets/social/quora.svg'),
  reddit: require('../assets/social/reddit.svg'),
  rss: require('../assets/social/rss.svg'),
  skype: require('../assets/social/skype.svg'),
  slack: require('../assets/social/slack.svg'),
  slideShare: require('../assets/social/slideshare.svg'),
  snapchat: require('../assets/social/snapchat.svg'),
  stackOverflow: require('../assets/social/stackoverflow.svg'),
  soundCloud: require('../assets/social/soundcloud.svg'),
  swarm: require('../assets/social/swarm.svg'),
  telegram: require('../assets/social/telegram.svg'),
  tiktok: require('../assets/social/tiktok.svg'),
  tumblr: require('../assets/social/tumblr.svg'),
  twitch: require('../assets/social/twitch.svg'),
  twitter: require('../assets/social/twitter.svg'),
  unsplash: require('../assets/social/unsplash.svg'),
  viber: require('../assets/social/viber.svg'),
  vine: require('../assets/social/vine.svg'),
  vk: require('../assets/social/vk.svg'),
  wechat: require('../assets/social/wechat.svg'),
  whatsapp: require('../assets/social/whatsapp.svg'),
  wordpress: require('../assets/social/wordpress.svg'),
  xing: require('../assets/social/xing.svg'),
  youtube: require('../assets/social/youtube.svg'),
  yy: require('../assets/social/yy.svg'),
  youtube: require('../assets/social/youtube.svg'),
  amazonshop: require('../assets/social/amazonshop.svg'),
  patreon: require('../assets/social/patreon.svg'),
  spotify: require('../assets/social/spotify.svg'),
}

export default new Vuetify({
  icons: {
    values: custom_icons
  }
});

Vue.use(Vuetify);